import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import appTheme from './theme/appTheme';
import GlobalTheme from './theme/GlobalTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <GlobalTheme />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Web-vitals collection is currently disabled.
reportWebVitals();
